export default {
	name: "",
	url: "",
	startDate: "",
	endDate: "",
	logo: "",
	city: "",
	state: "",
	metro_group: "",
	metro_sub_group: "",
	county: "",
	developers: null,
	builders: [],
	lat: "",
	lng: "",
	zip: "",
	goal: "",
	notify_emails: "",
	community_admins: "",
	weekly_message: "",
	portal_links: [],
	portal_message: "",
	addl_weekly_emails: "",
	arc_emails: "",
	info_center_email: "",
	facebook: "",
	instagram: "",
	youtube: "",
	color: "",
	active: "",
	secondary_color: "",
	accent_color: "",
	competitors: [],
	inventory_url: "",
	finance_data: {
		finance_name: "",
		finance_address: "",
		finance_city: "",
		finance_state: "",
		finance_zip: "",
		finance_phone: "",
		finance_email: "",
		funds_hoa: "",
		funds_development: "",
		funds_partnership: "",
		funds_lien: "",
		funds_disclosure: "",
		funds_proceeds: "",
		funds_district: "",
		hoa: "",
		hoa_schedule: "",
		commission: "",
		development_fee: "",
		partnership_development_fee: "",
		first_lien_release: "",
		net_gross: "",
		estimated_tax_rate: "",
		earnest_monies_net: "",
		closing_net_against_fl: "",
	},
	finance_custom: [],
}